import { MimeCategory } from '@common/enums';

export enum TreeItemTypes {
  SiteItem = 'SiteItem',
  SiteBlock = 'SiteBlock',
  SiteBlockItem = 'SiteBlockItem',
  File = 'File',
  Root = 'Root' // only for manual creation root node
}

export interface SiteDriveOdataItem {
  BackupOn: boolean;
  BaseTemplate: string;
  BlockId: string;
  CssClass: string;
  DomainId: string;
  DriveId: string;
  HierarchicalId: string;
  IconLink: string;
  Id: string;
  IsDriveItem: boolean;
  MimeCategory: MimeCategory;
  MimeTypeId: string;
  Name: string;
  ParentIdStr: string;
  Path: string;
  SiteName: string;
  Size: number;
  ThumbLink: string;
  TreeItemType: TreeItemTypes;
  Type: boolean;
}

export interface SiteOdataItem {
  BackupOn: boolean;
  DomainId: string;
  HierarchicalId: string;
  IconLink: string;
  Id: string;
  MimeCategory: MimeCategory;
  Name: string;
  TreeItemType: TreeItemTypes;
}

interface SiteOdataItemUI {
  BackupOnChanged?: boolean; // UI property for inside calculations
}

export interface SiteItemExtended extends SiteOdataItem, SiteOdataItemUI {}

export interface SiteItemDetails {
  '@odata.context'?: string;
  Description?: string;
  IconM?: string;
  IsDriveItem?: boolean;
  Raw?: string;
  children?: any[];
  Title?: string;
  Revisions?: SiteItemDetailsRevision[];
  value?: string;
  Path?: string[];
}

export interface SiteItemDetailsRevision {
  FileName: string;
  Id: string;
  ModifyDate: string; // "/Date(1578502905000)/"
  Raw: string;
}

export interface Site {
  '@odata.context'?: string;
  AutoAddSiteToBackup: boolean;
  EnabledAddSites: boolean;
  Id: string;
  LastBackupDate: string; // '2020-10-21T14:18:55.8262097Z'
  Size: number;
}

export interface PageSiteItemsPayload {
  siteId: string;
}

export interface PageDriveItemsPayload {
  siteBlockId: string;
  parentId: string;
  driveItemId: string;
}

export interface RestoreSiteItemsPayload {
  DestinationId?: string;
  Id: string;
  Name?: string;
  Overwrite?: boolean;
  Timeline?: string; // "2020-08-26T21:00:00.000Z";
}

export interface SetupSitesBackupPayload {
  sites: Partial<SiteItemExtended>[]; // Id: string; BackupOn: boolean;
}

export enum SearchType {
  SiteItems,
  Files,
  FilesInSiteItem
}

export type SearchODataOptions = {
  filter: string;
  orderBy: string;
  page: number;
  pageSize: number;
};

export type ItemSiteItemDetails = { site: SiteDriveOdataItem; details: SiteItemDetails };
